import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import residential from '../../json/residential-trash-and-recycling-data.json'

const residentialServiceData = {
  name: 'Residential Trash and Recycling Pickup',
  description:
    'Scheduled residential trash and recycling collection nationwide for homes, apartments, condos, HOAs, and short-term rentals, with a chosen arrival hour between 8am and 8pm, bulky item removal, and a diversion report after each service.',
  serviceType: 'Residential Trash and Recycling Collection',
  url: 'https://getdimension.com/residential-trash-and-recycling',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Weekly Household Trash Pickup' },
    { name: 'Biweekly Household Recycling Pickup' },
    { name: 'Monthly Large Item Pickup' },
    { name: 'Apartment and HOA Waste Collection' },
    { name: 'Short-Term Rental Turnover Cleanup' },
  ],
}

const residentialFAQData = {
  questions: residential.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function ResidentialTrashAndRecycling() {
  return (
    <>
      <Head>
        <title>Residential Trash and Recycling Pickup | Dimension</title>
        <meta
          name="description"
          content="Scheduled trash and recycling pickup for homes, apartments, HOAs, and rentals. Choose your day and arrival hour, add bulky items, save 15% recurring."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/residential-trash-and-recycling" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={residentialServiceData} />
        <SchemaMarkup type="FAQPage" data={residentialFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={residential.pitch.heading}
          material={residential.pitch.material}
          pitchText={residential.pitch.pitchText}
          ctaLink={residential.pitch.ctaLink}
          ctaText={residential.pitch.ctaText}
          ctaHeading={residential.pitch.ctaHeading}
          ctaSubtext={residential.pitch.ctaSubtext}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...residential.solutions} />
        <FeatureList {...residential.benefits} />
        <CaseStudy {...residential.caseStudy} />
        <Approach {...residential.approach} />
        <FAQ {...residential.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Recurring Waste Services',
              href: '/recurring-waste-services',
              description:
                'How scheduled collection works — cadences, arrival windows, and the 15% recurring discount.',
            },
            {
              label: 'Junk Removal Services',
              href: '/junk-removal',
              description:
                'Full-service pickup for a garage, basement, or whole-home clear-out in one visit.',
            },
            {
              label: 'Mattress Removal',
              href: '/mattress-removal',
              description:
                'The bulky item municipal crews refuse most often, collected and routed for recycling.',
            },
            {
              label: 'Dumpster Rental',
              href: '/dumpster-rental',
              description:
                'A container on site when a project produces more than a scheduled pickup can absorb.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default ResidentialTrashAndRecycling
